var Component   = require("enyo/Component"),
    L10nService = require("app/Domain/Ott/Api/V2/DataAccess/L10n/Service"),
    config      = require("app/config"),
    kind        = require("enyo/kind");

module.exports = kind(/** @lends app.l10n.L10nService.prototype */ {

    /**
     * @private
     */
    name: "app.l10n.L10nService",

    /**
     * @private
     */
    kind: Component,

    /**
     * The current country
     *
     * @type  {?string}
     * @public
     */
    country: null,

    /**
     * Resolve the country the current user is in.
     *
     * @returns  {Promise}  A promise that will resolve with the country.
     * @public
     */
    resolveCountry: function() {
        return L10nService.resolveCountry().then(this.bindSafely(function(response) {
            if (response.status === "ok") {
                this.set("country", response.data);
            }
            else {
                this.set("country", config.defaultCountry || null);
            }
        }));
    }

});
